module.exports = __webpack_public_path__ + "static/Phone Validation Technical Overview PE-968244b280cff54e4340a352193ea35c.pdf";